// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider[data-v-4762abe0]{width:100%}.divider-wrapper[data-v-4762abe0]{margin:10px 25px 40px;width:100%}@media screen and (max-width:1019px){.divider-wrapper[data-v-4762abe0]{margin:10px 0 40px;width:635px}}@media screen and (max-width:680px){.divider-wrapper[data-v-4762abe0]{margin:10px 0 40px;width:300px}}@media screen and (max-width:500px){.divider-wrapper[data-v-4762abe0]{margin:40px 15px;width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
